import axios from '../../plugins/TradutorInterceptor'

export const actions = {
    listConcessionarias(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('concessionarias' + payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    obterTodasConcessionarias(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('concessionarias?page=1&size=-1')
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/concessionaria.js